import jwtAuthAxios from 'app/services/auth/jwtAuth'
import utilServices from 'app/services/util-services'

const mapTermLookupList = (data) =>
    Array.isArray(data) ? data.map((row) => utilServices.mapTermApiDatesForDateEditors(row)) : data

const termServices = {}

termServices.getTermLookupList = async (filter) => {
    const queryParamter = new URLSearchParams(
        filter?.termYear
            ? { search: filter.termYear }
            : {
                  ...(filter?.past && { past: 'true' }),
                  ...(filter?.future && { future: 'true' }),
              }
    )
    const { data } = await jwtAuthAxios
        .get(`/api/course/Term/lookup/list?${queryParamter}`, filter)
        .catch(function (error) {
            if (error.response) {
                throw error.response.data
            } else if (error.request) {
                console.log(error.request)
                throw Error('request timed out')
            } else {
                console.log('Error', error.message)
            }
            console.log(error.config)
            throw Error(error.message)
        })
    return mapTermLookupList(data)
}

termServices.getTermLookupById = async (key) => {
    let url = `/api/course/Term/lookup/${key}`
    const { data } = await jwtAuthAxios.get(url, '').catch(function (error) {
        if (error.response) {
            throw error.response.data
        } else if (error.request) {
            throw Error('request timed out')
        } else {
            console.log('Error', error.message)
        }
        console.log(error.config)
        throw Error(error.message)
    })
    return utilServices.mapTermApiDatesForDateEditors(data)
}

termServices.getFutureTermLookupList = async (filter) => {
    console.log('filter getFutureTermLookupList= ', filter)
    const queryParamter = new URLSearchParams(
        filter?.termYear
            ? { search: filter.termYear }
            : {
                  ...(filter?.past && { past: 'true' }),
                  ...(filter?.future && { future: 'true' }),
              }
    )
    const { data } = await jwtAuthAxios
        .get(`/api/course/Term/lookup/list?${queryParamter}`, filter)
        .catch(function (error) {
            if (error.response) {
                throw error.response.data
            } else if (error.request) {
                console.log(error.request)
                throw Error('request timed out')
            } else {
                console.log('Error', error.message)
            }
            console.log(error.config)
            throw Error(error.message)
        })
    return mapTermLookupList(data)
}

export default termServices
